import { createComparisonOperators } from './core/operators/comparison-operators';
import { createElementMatchOperator } from './core/operators/element-match-operator';
import { evaluateDocument } from './core/evaluate-document';
export function createQubo(dataSource, options) {
    const baseOperators = createComparisonOperators();
    baseOperators['$elemMatch'] = createElementMatchOperator(baseOperators);
    const allOperators = {
        ...baseOperators,
        ...options?.operators,
    };
    return {
        evaluate(query) {
            return dataSource.map((document) => evaluateDocument(document, query, allOperators));
        },
        find(query) {
            return dataSource.filter((document) => evaluateDocument(document, query, allOperators));
        },
        findOne(query) {
            return dataSource.find((document) => evaluateDocument(document, query, allOperators));
        },
        evaluateOne(document, query) {
            return evaluateDocument(document, query, allOperators);
        },
    };
}
